export default __webpack_public_path__ + "static/media/lemontbotanique_m1.49a33b16.png";